import React, { Component } from 'react'
import { connect } from 'react-redux'
import SideSearchbar from '../../components/SideSearchbar/'
import { GetThemes, EditTheme, CreateThemeAction, DeleteTheme } from './ThemesAction'
import { Container, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog, Grid, Button, TextField } from '@material-ui/core';
import OverLoader from '../../components/common/loader';
import '../../App.css'
import { LogoutAction } from '../../actions';
import { Prompt } from "react-router-dom";

class Themen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      themeField: '',
      themeID: '',
      editMode: false,
      newTheme: '',
      editedTheme: '',
      deleteTheme: '',
      errorMessage: '',
      errorField: false,
      isBlocking: false,
      isDeleteContactDialogOpen: false
    }

    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (Number(access_rights.themes) === 2 && token !== null)
      this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { GetThemes } = this.props
    GetThemes()
  }
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { themes_list, new_theme, edited_theme, delete_success, error_validation, message_valid } = this.props
    const { themeID } = this.state
    if (nextProps.themes_list !== themes_list) {
      this.setState({ listData: nextProps.themes_list })
    }
    else if (nextProps.new_theme !== new_theme) {
      this.setState({ newTheme: nextProps.new_theme, isBlocking: false, themeID: nextProps.new_theme.id, editMode: true })
    }
    else if (nextProps.edited_theme !== edited_theme) {
      this.setState({ editedTheme: nextProps.edited_theme, isBlocking: false })
    } else if (nextProps.delete_success !== delete_success) {
      this.setState({ deleteTheme: themeID, themeField: '', isBlocking: false, editMode: false, })
    }
    else if (nextProps.error_validation !== error_validation || nextProps.message_valid !== message_valid) {
      this.setState({ errorMessage: nextProps.error_validation, errorField: true })
    }
  }

  getThemeData = (item) => {
    const { isBlocking } = this.state
    if (!isBlocking) {
      this.setState({ themeID: item.id, errorMessage: '', errorField: false, themeField: item.name, editMode: true })
      setTimeout(() => {
        this.focusTextInput()
      }, 100)
    } else {
      let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

      if (retVal === true) {
        this.setState({ isBlocking: false }, () => this.getThemeData(item))
      } else {
        this.setState({ isBlocking: false }, () => setTimeout(() => {
          this.setState({ isBlocking: true })
        }, 1000))
      }
    }
  }

  editTheme = () => {
    const { themeID, themeField } = this.state
    const { EditTheme } = this.props
    EditTheme(themeID, themeField)
  }

  createTheme = () => {
    const { CreateThemeAction } = this.props
    const { themeField } = this.state
    if (themeField !== '') {
      CreateThemeAction(themeField)
    }
  }
  deleteTheme = () => {
    const { DeleteTheme } = this.props
    const { themeID } = this.state
    DeleteTheme(themeID)
    this.setState({ isDeleteContactDialogOpen: false })
    setTimeout(() => {
      this.focusTextInput()
    }, 100)
  }
  openDeleteDialog = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })

  }
  resetForm = () => {
    this.setState({ themeField: '', errorMessage: '', isBlocking: false, errorField: false, themeID: '', editMode: false })
    setTimeout(() => {
      this.focusTextInput()
    }, 200)
  }

  render() {
    const { deleteTheme, errorMessage, isBlocking, errorField, isDeleteContactDialogOpen, editMode, listData, themeField, newTheme, editedTheme } = this.state
    const { isloading } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="xl">
          <Grid container spacing={3} className="mainBlock">
            <Grid item md={3} sm={4} xs={12}>
              <div className="leftSide">
                <SideSearchbar
                  tittle={"Neues Thema"}
                  listData={listData}
                  newList={newTheme}
                  editedList={editedTheme}
                  deleteList={deleteTheme}
                  getDataOfSelectedItemFunc={this.getThemeData}
                  createNewListFunc={this.resetForm}
                  isRight={Number(access_rights.themes)}
                />
              </div>
            </Grid>
            <Grid item md={9} sm={8} xs={12} className={`${Number(access_rights.themes) === 1 ? "disableALlFields" : ""}`}
            >
              <Prompt
                when={isBlocking}
                message={location =>
                  `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                }
              />
              <div className="rightBlock liproCard">
                <div className="mb2">
                  <label className="mb1">Thema</label>
                  <TextField
                    inputProps={{
                      maxLength: 40
                    }}
                    helperText={errorField ? errorMessage.theme ? errorMessage.theme : errorMessage : ''} error={errorField ? true : false}
                    inputRef={this.textInput} size="small" value={themeField} className="innerInput" onChange={(e) => {
                      this.setState({ themeField: e.target.value, isBlocking: true, errorField: false })
                    }} variant="outlined" />
                </div>
                {Number(access_rights.themes) !== 1 &&
                  <div className="actionBtn">
                    {editMode ?
                      <Button variant="outlined" color="primary" onClick={() => { this.editTheme() }} >Speichern</Button>
                      :
                      <Button variant="outlined" color="primary" onClick={() => { this.createTheme() }} >Hinzufügen</Button>
                    }
                    {editMode &&
                      <Button variant="outlined" color="primary" onClick={() => { this.openDeleteDialog() }} >Löschen</Button>
                    }
                    <Dialog
                      open={isDeleteContactDialogOpen}
                    >
                      <DialogTitle>Thema löschen</DialogTitle>
                      <DialogContent>
                        <DialogContentText >
                          Sind Sie sicher?
              </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.deleteTheme} size="small" variant="outlined" color="primary" autoFocus>
                          Bestätigen
              </Button>
                        <Button onClick={this.closeDeleteContactDialog} size="small" variant="outlined" color="secondary">
                          Abbrechen
              </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                }
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = ({ theme }) => {
  return {
    isloading: theme.loading,
    themes_list: theme.themes_list,
    message_valid: theme.message_valid,
    new_theme: theme.new_theme,
    edited_theme: theme.edited_theme,
    delete_success: theme.success,
    error_validation: theme.error_message,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetThemes: () => dispatch(GetThemes()),
    EditTheme: (id, name) => dispatch(EditTheme(id, name)),
    CreateThemeAction: (id, name) => dispatch(CreateThemeAction(id, name)),
    DeleteTheme: (id) => dispatch(DeleteTheme(id)),
    LogoutAction: () => dispatch(LogoutAction()),

  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Themen)